// @flow
import type { Epic } from '../../../annotations';
import type {
  SendAnalytics,
} from '../../../core/ga';

import { FILTER } from '../../signals';
import { filtering } from '../../../domain/messages';
import { mapFiltersToGa } from '../../../domain/ga';
import { getDst } from '../../../domain/selectors';
import { select } from 'redux-most';
import * as most from 'most';
import * as r from 'ramda';
import * as mostc from '../../../crosscutting/mostc';

const filterEpic = (
  sendAnalytics: SendAnalytics,
): Epic => (
  actions$,
  store,
) => r.pipe(
  select(FILTER),
  mostc.tap(({
    payload: {
      filters,
    },
  }) => {
    const state = store.getState();
    const { filters: originalFilters } = getDst(state);

    r.pipe(
      mapFiltersToGa,
      r.map(sendAnalytics),
      // $FlowFixMe
    )(filters, originalFilters);
  }),
  mostc.map(({
    payload,
  }) => {
    return most.of(filtering(payload.filters));
  }),
  most.switchLatest,
)(actions$);

export default filterEpic;
